"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Loading_1 = __importDefault(require("../Spinners/Loading"));
// eslint-disable-next-line react/display-name
var WithServiceState = function (WrappedComponent) {
    // eslint-disable-next-line react/display-name
    return function (_a) {
        var showLoadingText = _a.showLoadingText, loading = _a.loading, loaderType = _a.loaderType, loaderWheelType = _a.loaderWheelType, data = _a.data, placeholderBlockCount = _a.placeholderBlockCount;
        var getLoaderType = function () {
            switch (loaderType) {
                case "indicator":
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "loading-indicator-wrapper fadeIn" },
                            react_1.default.createElement("div", { className: "loading-indicator" },
                                react_1.default.createElement(Loading_1.default, { type: loaderWheelType, showLoadingText: showLoadingText })))));
                case "overlay":
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "loading-overlay fadeIn" },
                            react_1.default.createElement("div", { className: "loading-overlay-content" },
                                react_1.default.createElement(Loading_1.default, { type: loaderWheelType, showLoadingText: showLoadingText })))));
                case "normal":
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "loading-normal-wrapper" },
                            react_1.default.createElement(Loading_1.default, { type: "three-ring", showLoadingText: showLoadingText }))));
            }
        };
        var getPlaceHolderBlockCount = function () {
            if (!placeholderBlockCount) {
                return react_1.default.createElement("div", { className: "pt-pb-5" });
            }
            var placeHolderBlocks = [];
            for (var i = 0; i < placeholderBlockCount; ++i) {
                placeHolderBlocks.push(react_1.default.createElement("div", { className: "placeholder-loader" }));
            }
            return react_1.default.createElement("div", { className: "pt-pb-5" }, placeHolderBlocks);
        };
        return (react_1.default.createElement(react_1.default.Fragment, null,
            loading && getLoaderType(),
            data ? react_1.default.createElement(WrappedComponent, __assign({}, data)) : getPlaceHolderBlockCount()));
    };
};
exports.default = WithServiceState;
